export default {
  defaultObject () {
    return {
      id: undefined,
      name: '',
      coursesIds: [],
      holes: [],
      isActive: true
    }
  },

  holesDefaultObject () {
    return {
      holeId: undefined,
      name: undefined,
      par: null
    }
  }
}